import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { loadPageSeo, getPageSeo, applySeo } from '../../utils/pageSeo';

// Applies URL-based SEO overrides (configured in admin → SEO) on route change.
// Dynamic pages (product/blog) set their own meta, but if an admin has added an
// explicit entry for that exact URL, it wins.
export default function RouteSeo() {
  const { pathname } = useLocation();
  const [ready, setReady] = useState(false);
  // Tracks whether the title currently shown was set by THIS component, so we
  // only reset titles we own — never a product/blog page's own title.
  const managed = useRef(false);

  useEffect(() => { loadPageSeo().then(() => setReady(true)); }, []);

  useEffect(() => {
    const entry = getPageSeo(pathname);
    if (entry) {
      applySeo(entry);
      managed.current = true;
    } else if (managed.current) {
      document.title = 'TheYellove';
      managed.current = false;
    }
  }, [pathname, ready]);

  return null;
}
